
import { commonTranslations } from './common';
import { heroTranslations } from './hero';
import { visionTranslations } from './vision';
import { benefitsTranslations } from './benefits';
import { audienceTranslations } from './audience';
import { testimonialsTranslations } from './testimonials';
import { ctaTranslations } from './cta';
import { manifestoTranslations } from './manifesto';
import { footerTranslations } from './footer';

// Combine all translations
export const translations = {
  ...commonTranslations,
  ...heroTranslations,
  ...visionTranslations,
  ...benefitsTranslations,
  ...audienceTranslations,
  ...testimonialsTranslations,
  ...ctaTranslations,
  ...manifestoTranslations,
  ...footerTranslations
};

export type Language = 'fr' | 'en';

// Re-export the useTranslation hook
export { useTranslation } from '../i18n';
